import React, {Component, Fragment} from 'react';
import PropTypes from 'prop-types'
import {Helmet} from 'react-helmet';
import {withRouter} from 'react-router-dom';
import {connect} from 'react-redux';
import {getSidebarContent} from '../../Content/actions';
import ReactHtmlParser from 'react-html-parser';
import SectionTitle from '../../Layout/components/SectionTitle';
import ContactForm from './ContactForm';
import ContactMap from './ContactMap';
import LoadingSpinner from '../../Layout/components/LoadingSpinner';
import {withLocalize} from 'react-localize-redux';
import translations from '../translations/translations_contact';

class ContactContainer extends Component {
    fetchContent() {
        const {loading} = this.props;

        if (!loading) {
            this.props.getSidebarContent('agep_contact');
        }
    }

    constructor(props) {
        super(props);

        this.props.addTranslation(translations);
    }

    componentDidMount() {
        this.fetchContent();
    }

    componentDidUpdate(prevProps, prevState) {
        if (prevProps.languages !== this.props.languages) {
            const {pathname} = this.props.location;
            const expectedUri = this.props.translate('routes.contact');

            if (pathname !== expectedUri) {
                this.props.history.push(expectedUri);
            } else {
                this.fetchContent();
            }
        }
    }

    render() {
        const {sidebar, loading} = this.props;

        const pageTitle = this.props.translate('contact.page_title') + ' ' + process.env.REACT_APP_HEAD_TITLE_SEPARATOR + ' ' + process.env.REACT_APP_SITE_TITLE;

        if (sidebar.agep_contact === null || sidebar.agep_contact === undefined || loading) {
            return (
                <Fragment>
                    <Helmet
                        bodyAttributes={{
                            class: 'contact vertical-content-force-height-100'
                        }}
                    >
                        <title>{pageTitle}</title>
                    </Helmet>
                    <div className="container">
                        <div className="row mt-0 mb-0 align-items-center" style={{height: '100%'}}>
                            <div className="col-3 mx-auto">
                                <div className="text-center">
                                    <LoadingSpinner/>
                                </div>
                            </div>
                        </div>
                    </div>
                </Fragment>
            );
        }

        let widgets = sidebar.agep_contact.widgets;

        let title = <Fragment>{ReactHtmlParser(widgets.titre.data.content)}</Fragment>;

        return (
            <Fragment>
                <Helmet
                    bodyAttributes={{
                        class: 'contact'
                    }}
                >
                    <title>{pageTitle}</title>
                </Helmet>
                <div className="container">
                    <SectionTitle cssClass="page-title" title={title} subtitle={widgets.description.data.content} />

                    <div className="mt-30 mb-30 mt-lg-90 mb-lg-90">
                        <ContactForm/>
                    </div>
                </div>
                <ContactMap />
            </Fragment>
        );
    }
}

ContactContainer.propTypes = {
    getSidebarContent: PropTypes.func.isRequired,
    translate: PropTypes.func.isRequired,
};

const mapStateToProps = (state) => ({
    sidebar: state.content.sidebar,
    loading: state.content.sidebarLoading,
    errors: state.errors,
    languages: state.localize.languages,
});

export default withRouter(connect(mapStateToProps, {getSidebarContent})(withLocalize(ContactContainer)));



// WEBPACK FOOTER //
// ./src/features/Contact/components/ContactContainer.js